export default __webpack_public_path__ + "admin-map-500-bf8305986c3f871e00a379f4e2fb2061.webp";